(ns web3.ui-state
  (:require [reagent.core :as r]
            [re-frame-simple.db :as db]
            [goog.events :as events]
            [web3.view :as v]
            [web3.utils :as utils]))

(def MOBILE_BREAKPOINT 700)
(def WIDE_BREAKPOINT 1000)

(defn get-ui-globals []
  #:window {:inner-width (.-innerWidth js/window)
            :inner-height (.-innerHeight js/window)
            :scroll-y (.-scrollY js/window)
            :scroll-x (.-scrollX js/window)})

(defonce ui-globals (r/atom (get-ui-globals)))

(defonce listen-window!
         (delay
           (events/listen js/window #js ["scroll" "resize"]
                          #(reset! ui-globals (get-ui-globals)))))

(db/defquery mobile? []
  @listen-window!
  (<= (:window/inner-width @ui-globals) MOBILE_BREAKPOINT))

(db/defquery wide? []
  @listen-window!
  (>= (:window/inner-width @ui-globals) WIDE_BREAKPOINT))

(db/defquery modal-state []
  @listen-window!
  (let [{:router/keys [form-modal
                       content-modal
                       drawer]
         :as routers} (db/get :db/routers)
        alert? (seq (db/get :modal-alerts/frames))
        mobile? (mobile?)]
    (let [full-modal? (boolean (or form-modal
                                   content-modal))]
      (merge
        (utils/map-vals boolean routers)
        {:full-modal? full-modal?
         :alert? alert?
         :mobile? mobile?
         :any-modal? (boolean (or full-modal? drawer))
         :scroll-lock? (and (not mobile?)
                            (boolean (or full-modal?
                                         alert?
                                         drawer)))}))))

;; ========== Window Size ==========

(def manage-scroll
  {:will-receive-props
   (fn [key {:as this
             :keys [state props]}]
     (when (and (:active? props)
                (not (:active? (:view/prev-props @(:state this)))))
       (v/swap-silently! state assoc :prev-scrollY (.-scrollY js/window))
       (when (mobile?)
         (.scrollTo js/window 0 0)))
     (v/swap-silently! state assoc :view/prev-props props))
   :did-update
   (fn [key {:as this
             :keys [props state]}]
     (when-let [y (and (:active? props)
                       (:prev-scrollY @state))]
       (when (mobile?)
         (.scrollTo js/window 0 y))
       (v/swap-silently! state dissoc :prev-scrollY)))
   :inactive-styles
   {:max-height "100vh"
    :overflow "hidden"
    :position "absolute"
    :top 0
    :left 0
    :right 0}})